import React, { ReactElement, useState } from "react";
import { Button, ButtonProps, Popover, PopoverBody } from "reactstrap";
import { FaCopy } from "react-icons/fa";

const CopyButton = (props: ButtonProps): ReactElement => {
  const [isOpen, setIsOpen] = useState(false);

  const handleCopy = (): void => {
    const value = props.value ? props.value.toString() : "";
    navigator.clipboard.writeText(value);
    setIsOpen(true);
    setTimeout(() => setIsOpen(false), 2000);
  };

  return (
    <>
      <Button
        color="secondary"
        size="sm"
        onClick={handleCopy}
        {...props}
      >
        <FaCopy className="mr-1" size="16" />
        Copy
      </Button>
      <Popover
        placement="bottom"
        target={props.id || ""}
        isOpen={isOpen}
        fade={false}
      >
        <PopoverBody>{props.title || "Text"} copied.</PopoverBody>
      </Popover>
    </>
  );
};

export default CopyButton;
